import MultiLanguageDesignationModel from './MultiLanguageDesignationModel';
import * as AT from '../../components/container/attributes';

export default class StaffCompensationType extends MultiLanguageDesignationModel {
  constructor({
    id,
    number,
    designationFrBe = undefined,
    designationDeBe = undefined,
    designationNlBe = undefined,
    designationFrLu = undefined,
    designationDeLu = undefined,
    designationFrFr = undefined,
    designationDeDe = undefined,
    designationNlNl = undefined,
    designationEnGb = undefined,
    designationEnIn = undefined,
    designationMrIn = undefined,
    designationHiIn = undefined,
    resource = undefined,
    no = undefined,
    designation = undefined,
  }) {
    super({
      id,
      number: number || no,
      designationFrBe,
      designationDeBe,
      designationNlBe,
      designationFrLu,
      designationDeLu,
      designationFrFr,
      designationDeDe,
      designationNlNl,
      designationEnGb,
      designationEnIn,
      designationMrIn,
      designationHiIn,
    });
    this.resource = resource;
    if (designation) {
      this.designation = designation;
    }
  }

  static get config() {
    const config = MultiLanguageDesignationModel.config;
    config['importable'] = false;
    return config;
  }

  get config() {
    return StaffCompensationType.config;
  }

  static get fkName() {
    return 'staff_compensation_type_id';
  }

  static get apiRoute() {
    return 'staff_compensation_type';
  }

  static get listPageRoute() {
    return 'compensationList';
  }

  static get detailPageRoute() {
    return 'compensationDetail';
  }

  static get createInitColumns() {
    return {};
  }

  get fkName() {
    return StaffCompensationType.fkName;
  }

  get apiRoute() {
    return StaffCompensationType.apiRoute;
  }

  get detailPageRoute() {
    return StaffCompensationType.detailPageRoute;
  }

  get listPageRoute() {
    return StaffCompensationType.listPageRoute;
  }

  get createInitColumns() {
    return StaffCompensationType.createInitColumns;
  }

  static get listDisplayAttrs() {
    return this.getAttributes(
      [
        'number',
        this.attributeUserLocale('designation'),
        this.attributeCompanyLocale('designation'),
      ],
      ['resource'],
    );
  }

  static get browserDisplayAttrs() {
    return this.getAttributes(
      [
        'number',
        this.attributeUserLocale('designation'),
        this.attributeCompanyLocale('designation'),
      ],
      ['resource'],
    );
  }

  static get joinAttrsKey() {
    return [
      'number',
      this.attributeUserLocale('designation'),
      this.attributeCompanyLocale('designation'),
    ];
  }

  static get allAttributes() {
    return [
      this.NUMBER_ATTRIBUTE({}, {maxWidth: '1fr'}),
      new AT.FkResourceAttribute({
        name: 'resource',
        fkToUpdate: 'resource_id',
        joinPath: ['resource!fk_staff_compensation_type_resource_id_resource'],
        tableProperties: {
          header: 'hit-base.common.resource',
        },
      }),
    ].concat(
      this.generateMultiLanguageField({
        key: 'designation',
        attributeClass: AT.StringAttribute,
        header: 'hit-base.common.designation',
      }),
    );
  }
}
